import { createSlice } from '@reduxjs/toolkit';

import { loadCurrentResidentsItem, loadCurrentResidentsList } from './actions';
import { CurrentResidentsState } from './interfaces';

export const currentResidentsSlice = createSlice({
  name: 'currentResidents',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as CurrentResidentsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadCurrentResidentsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(
      loadCurrentResidentsItem.fulfilled,
      (state, { payload }) => {
        state.item = payload;
      }
    );
  },
});
